import { render, staticRenderFns } from "./Audit.vue?vue&type=template&id=0cff96f7&scoped=true"
import script from "./Audit.vue?vue&type=script&lang=js"
export * from "./Audit.vue?vue&type=script&lang=js"
import style0 from "./Audit.vue?vue&type=style&index=0&id=0cff96f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cff96f7",
  null
  
)

export default component.exports